"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var field = ui_blocks_1.FORM.field;
var ColorPatterns;

(function (ColorPatterns) {
  ColorPatterns["light"] = "GREY.WHITE";
  ColorPatterns["dark"] = "GREY[\"200\"]";
})(ColorPatterns || (ColorPatterns = {}));

var Sizes;

(function (Sizes) {
  Sizes[Sizes["small"] = 4] = "small";
  Sizes[Sizes["medium"] = 5] = "medium";
})(Sizes || (Sizes = {}));

var SizePadding;

(function (SizePadding) {
  SizePadding[SizePadding["small"] = 7] = "small";
  SizePadding[SizePadding["medium"] = 9] = "medium";
})(SizePadding || (SizePadding = {}));

var makePatternStyles = function makePatternStyles(colorPattern, theme) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(ColorPatterns[colorPattern]), theme));
};

var makeSizeStyles = function makeSizeStyles(sizeOption, theme) {
  var _a, _b;

  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  padding-right: ", ";\n"], ["\n  height: ", ";\n  padding-right: ", ";\n"])), (0, ui_symbols_1.calcSpace)(Sizes[sizeOption], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP), (0, ui_symbols_1.calcSpace)(SizePadding[sizeOption], (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP));
};

exports.Input = styled_components_1.default.input(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  border-radius: ", ";\n  padding-left: ", ";\n  width: 100%;\n  ", "\n  ", "\n\n  &:focus + button {\n    background: ", ";\n    color: ", ";\n  }\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n"], ["\n  ", "\n  border-radius: ", ";\n  padding-left: ", ";\n  width: 100%;\n  ", "\n  ", "\n\n  &:focus + button {\n    background: ", ";\n    color: ", ";\n  }\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n"])), field, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.DEFAULT', theme);
}, (0, ui_symbols_1.calcSpace)(2), function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'colorPattern', makePatternStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
var templateObject_1, templateObject_2, templateObject_3;